/*
  Aza Natural: compacte koopkeuze in twee rijen (Inhoud en Aantal), upgrade PDP-01.

  De markup staat in snippets/aza-variant-picker.liquid. Deze rijen zijn alleen
  een bediening: ze zetten de bestaande (verborgen) radio van de gekozen
  optiewaarde aan. Het change-event bubbelt daarna door naar <product-variants>
  (component-product-form.js), dat prijs, knop, voorraad en URL bijwerkt. Zo
  blijven de variant-ID's, de strenge voorraadregel en de sticky koopbalk
  precies werken zoals ze werkten.
*/
if (!customElements.get('aza-koopkeuze')) {
  class AzaKoopkeuze extends HTMLElement {
    connectedCallback() {
      if (this._klaar) return;
      this._klaar = true;
      this.varianten = this.closest('product-variants');
      if (!this.varianten) return;
      // Deze listener zit op een kind van <product-variants>, dus hij loopt
      // vóór onVariantChange daar.
      this.addEventListener('change', (e) => this.opWijziging(e));
      this.varianten.addEventListener('VARIANT_CHANGE', () => this.volgBron());
      this.volgBron();
    }

    bronInputs() {
      return [...this.varianten.querySelectorAll('[data-js-product-variant-container] .product-variant__input')];
    }

    tegels(maat) {
      return [...this.querySelectorAll('.aza-koopkeuze__tegel')].filter((t) => maat === undefined || t.dataset.maat === maat);
    }

    toonTegels(maat) {
      this.tegels().forEach((t) => { t.hidden = t.dataset.maat !== maat; });
    }

    kies(waarde) {
      const bron = this.bronInputs().find((i) => i.value === waarde);
      if (bron) bron.checked = true;
    }

    opWijziging(e) {
      const doel = e.target;
      if (!(doel instanceof HTMLInputElement)) return;
      if (doel.name.startsWith('aza-maat-')) {
        const maat = doel.value;
        const huidigeN = this.querySelector('input[name^="aza-aantal-"]:checked')?.dataset.n;
        const opties = this.tegels(maat).map((t) => t.querySelector('input'));
        const keuze = opties.find((i) => i.dataset.n === huidigeN && i.dataset.beschikbaar === 'true')
          || opties.find((i) => i.dataset.beschikbaar === 'true')
          || opties[0];
        this.toonTegels(maat);
        if (keuze) {
          keuze.checked = true;
          this.kies(keuze.value);
        }
      } else if (doel.name.startsWith('aza-aantal-')) {
        this.kies(doel.value);
      }
    }

    // Bij laden (ook ?variant=...) en na elke wissel: de rijen volgen de bron.
    volgBron() {
      const bron = this.bronInputs().find((i) => i.checked);
      if (!bron) return;
      const tegelInput = this.tegels().map((t) => t.querySelector('input')).find((i) => i.value === bron.value);
      if (!tegelInput) return;
      tegelInput.checked = true;
      const maat = tegelInput.closest('.aza-koopkeuze__tegel').dataset.maat;
      const pil = [...this.querySelectorAll('input[name^="aza-maat-"]')].find((i) => i.value === maat);
      if (pil) pil.checked = true;
      this.toonTegels(maat);
    }
  }
  customElements.define('aza-koopkeuze', AzaKoopkeuze);
}
